import videojs from "video.js";
import $ from 'jquery';

export default function customVideo (videoElement) {
    const videoFormat = $(videoElement).data('custom-video-type');
    const videoUrl = $(videoElement).data('custom-video-src');
    const poster = $(videoElement).data('custom-video-poster');

    if (videoFormat && videoUrl) {
        let source = {
            src: videoUrl,
            type: null,
        };
        let techOrder = [];

        if (videoFormat === 'mp4') {
            source.type = 'video/mp4';
            techOrder.push('html5');
        }

        if (videoFormat === 'youtube') {
            source.type = 'video/youtube';
            techOrder.push('youtube');
        }

        const videoJsOptions = {
            controls: true,
            preload: 'auto',
            sourceOrder: true,
            customControlsOnMobile: false,
            nativeControlsForTouch: true,
            hls: {
                withCredentials: true
            },
            sources: [source],
            techOrder: techOrder,
            youtube: {
                customVars: {
                    wmode: 'transparent',
                }
            },
        };

        if(poster) {
            videoJsOptions.poster = poster;
        }

        return videojs(videoElement, videoJsOptions);
    }
}
